<template>
<div>
  <div v-if="isSuccess" class="container container-msg">
    <div class="space-100"></div>
    <div v-if="typeResponse" class="jumbotron">
      <h1 class="display-4 text-center">¡Bienvenido!</h1>
      <p class="lead"></p>
      <hr class="my-4">
      <p class="text-center">Apartir de ahora empieza a acumular puntos para disfrutar de grandes descuentos y beneficios en los comercios afiliados.</p>
      <p class="text-center">
        <router-link  to="/login">
          <n-button type="success" class="btn btn-primary btn-lg" role="button">Comenzar</n-button>
        </router-link>
      </p>
      <router-link  to="/">
        <p class="text-center back-a">Regresar al inicio</p>
      </router-link>
    </div>
    <div v-if="!typeResponse" class="jumbotron">
      <h1 class="display-4 text-center">Tu solicitud fué recibida!</h1>
      <p class="lead"></p>
      <hr class="my-4">
      <p class="text-center">No volverás a recibir correos promocionales.</p>
      <router-link  to="/">
        <p class="text-center back-a">Regresar al inicio</p>
      </router-link>
    </div>
  </div>
  <div v-if="error" class="container container-msg">
    <div class="space-100"></div>
    <div class="jumbotron">
      <h1 class="display-4 text-center">¡Ups!</h1>
      <p class="lead"></p>
      <hr class="my-4">
      <p class="text-center">Algo salio mal, por favor inténtelo de nuevo, si el problema persiste contacte al administrador.</p>
      <router-link  to="/">
        <p class="text-center back-a">Regresar al inicio</p>
      </router-link>
    </div>
  </div>
</div>
</template>
<script>
import { Card, FormGroupInput, Button, Tabs, TabPane, Modal} from '@/components';
import LoginService from '../service/core/login.service'
import base64url from "base64url";

export default {
  components: {
    Card,
    Tabs,
    TabPane,
    Modal,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data(){
    return {
      loginService: new LoginService(),
      modals: {
          classic: false,
      },
      decode: '',
      isSuccess: false,
      typeResponse: true,
      error: false
    }
  },
  mounted(){
    let url = this.getD2()
    let realUrl = ''
    if(url.includes("%3D")){
      realUrl = url.replace('%3D', '=')
    }

    this.decode = base64url.decode(this.getD2())
    let conditions = {
      "info":{
        "type": this.getType(),
        "d1": this.getD1(),
        "d2": this.getD2()
      }
    }
    this.loginService.confirmAccount(conditions).then(data => {
      this.isSuccess = true
      if(this.getType() > 1){
        this.typeResponse = false
      }
    }, err => {
      this.isSuccess = false
      this.error = true
    })
  },
  methods:{
    getType(){
      let type = location.href.split('=')
      let typeNum = type[1].split('&')
      return typeNum[0]
    },
    getD1(){
      let d1 = location.href.split('=')
      let d1Num = d1[2].split('&') 
      return d1Num[0]
    },
    getD2(){
      let d2 = location.href.split('=')
      return d2[3]
    },
    getAccount(){
      let account = this.decode.split(':')
      return account[0]
    },
    getPassword(){
      let password = this.decode.split(':')
      return password[1]
    },
    login(){
      location.href="/PerfilUsuario";
    }
  }
}
</script>
<style lang="scss">
#javascriptComponents {
  .modal-buttons,
  .popover-buttons,
  .tooltip-buttons {
    .btn + .btn {
      margin-left: 3px;
    }
  }
}
.container-msg{
  margin-bottom: 5rem;
}
.tab-content.tab-content-padding {
  padding: 20px;
}
.colorA{
    background-color: rgba(165, 42, 42, 0.288);
}
.colorB{
    background-color: rgba(0, 0, 255, 0.24);
}
.more-info-space{
    margin: 10px 0px 10px 10px;
}
.margin-defult{
    margin: 0px;
}
.count-title{
    margin: 0px;
}

.count-info{
    margin: 10px;
}
.QRcode{
    width: 50%;
    margin: 20px;
}
.valid-button{
    width: 50%;
    height: 40px;
}
.text-color-blue{
    color: #00bbff;
}
.money-title{
    margin: 5px;
}
.line-border{
    border-bottom: 1px solid #474646d7
}
.icon-title{
    width: 25px;
}
.comer-img{
    width:65%;
    margin: 10px;
}
.borders-defult{
    width: 23%;
    padding: 5px;
    margin: 5px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #000000;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
}
.cupon-img{
    padding: 30px 5px 30px 5px;
}
.validity-date{
    margin: 0px;
    font-size: 10px;
    padding-left: 140px;
}
.row-info{
    margin: 10px;
}
.editar-button{
    margin-top: 10px;
}
.icon-info{
    width: 20px;
}
.money-title{
    color:#000000;
}
.back-a{
  color: #35353575;
  font-size: 15px;
}

</style>
